module.exports = __webpack_public_path__ + "static/media/pin-property.6c43ac63.svg";